import React from 'react';
import { Section } from './ui/Section';
import { BrainCircuit, Sparkles, ScrollText } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = [{
    icon: BrainCircuit,
    title: 'Reacción Automática',
    description: 'Pasas los días reaccionando al estrés, a las opiniones de otros y a la falta de tiempo.'
  }, {
    icon: Sparkles,
    title: 'Búsqueda Constante',
    description: "Sientes que hay 'algo más', pero no sabes cómo acceder a ese poder interno."
  }, {
    icon: ScrollText,
    title: 'Guion Viejo',
    description: 'Sigues repitiendo patrones del pasado sin saber cómo reescribir tu historia.'
  }];
  return <div className="bg-navy text-cream py-20" data-id="element-95">
      <Section data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <span className="text-sage text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-98">
            El mundo te dice qué ser, pero tu alma ya lo sabe
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold max-w-3xl mx-auto leading-tight" data-id="element-99">
            El problema no es que te falte suerte o voluntad. <br data-id="element-100" />
            <span className="text-sage/90" data-id="element-101">
              El problema es que estás operando desde un guion viejo.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-102">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-navy/50 border border-white/10 p-8 rounded-2xl hover:bg-white/5 transition-colors duration-300" data-id="element-103">
              <div className="w-12 h-12 bg-sage/20 rounded-full flex items-center justify-center mb-6 text-sage" data-id="element-104">
                <pain.icon size={24} data-id="element-105" />
              </div>
              <h3 className="text-xl font-bold mb-4 font-heading" data-id="element-106">
                {pain.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-107">
                {pain.description}
              </p>
            </motion.div>)}
        </div>
      </Section>
    </div>;
}